import React from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { RefreshCw } from "lucide-react"; // Ou une autre icône de votre choix

// Définition des props que le bouton acceptera
interface ZoomResetButtonProps {
  initialCenter: L.LatLngExpression;
  initialZoom: number;
  onReset?: () => void;
}

const ZoomResetButton: React.FC<ZoomResetButtonProps> = ({
  initialCenter,
  initialZoom,
  onReset,
}) => {
  // Le hook `useMap` nous donne accès à l'instance de la carte Leaflet
  const map = useMap();

  const handleReset = () => {
    // `setView` est la fonction Leaflet pour centrer et zoomer la carte
    map.setView(initialCenter, initialZoom);
    if (onReset) {
      onReset();
    }
  };

  const buttonStyle: React.CSSProperties = {
    position: "absolute",
    top: "73px", // Ajustez pour placer sous les boutons +/-
    left: "11px",
    zIndex: 1000, // Doit être au-dessus des tuiles de la carte
    cursor: "pointer",
    backgroundColor: "white",
    border: "2px solid rgba(0,0,0,0.2)",
    borderRadius: "4px",
    fontSize: "22px",
    width: "32px", // Même largeur que les boutons de zoom
    height: "30px", // Même hauteur
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 1px 1px rgba(0,0,0,0.65)",
  };

  return (
    <button onClick={handleReset} style={buttonStyle} title="Reset view">
      <RefreshCw size={16} />
    </button>
  );
};

export default ZoomResetButton;
